import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const MySingleProduct = (props) => {
  let {
    photoURL,
    productCategory,
    productDescription,
    productName,
    productPrice,
    productQuantity,
    _id,
  } = props?.info;
  const slug = `/product/${_id}`;

  if (productDescription.length > 60) {
    productDescription.substring(0, 60);
  }
  // handle Quantity
  const [upQuantity, setUpQuantity] = useState(productQuantity);
  const handleQuantity = () => {
    // update Request
    let url = `https://rocky-ravine-79485.herokuapp.com/product/edit-q/${_id}?quantity=${
      parseInt(upQuantity) - 1
    }`;
    axios
      .put(url, {
        productQuantity: parseInt(upQuantity) - 1,
      })
      .then((res) => {
        setUpQuantity(parseInt(upQuantity) - 1);
      });
  };

  // handle Delete
  const { deleteBtn } = props;
  return (
    <div className="rounded">
      <>
        <Row className="product-grid h-auto shadow rounded">
          <Col md="2" sm="12">
            <div className="product-image">
              <Link to={slug} className="image">
                <img
                  style={{ height: "100px", width: "140px" }}
                  className="pic-1"
                  src={photoURL}
                  alt=""
                />
              </Link>
            </div>
          </Col>
          <Col md="6" sm="12">
            <div className="product-content text-start d-flex flex-column">
              <span className="product-category">
                <Link to={slug}>{productName}</Link>
              </span>
              <div className="title text-black">
                <p>
                  {productDescription.length > 60
                    ? productDescription.substring(0, 60)
                    : productDescription}{" "}
                  ...
                </p>
              </div>
              <Row className="align-items-center">
                <Col md="6" className="d-flex gap-4 align-items-center">
                  <span className="price ">Price: ${productPrice}</span>
                  <span className="price ">
                    Quantity: {parseInt(upQuantity)}
                  </span>
                </Col>
                <Col md="6">
                  <Button onClick={handleQuantity} variant="success">
                    {" "}
                    Deliver A Item
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md="4" sm="12">
            <div className="d-flex h-100 gap-4 justify-content-end align-items-center">
              <Link
                to={`/product/edit/${_id}`}
                variant=""
                className="btn btn-warning text-white"
              >
                {" "}
                &#9998; Edit
              </Link>
              <Button onClick={() => deleteBtn(_id)} className="btn btn-danger">
                Delete
              </Button>
            </div>
          </Col>
        </Row>
      </>
    </div>
  );
};

export default MySingleProduct;
